import { Combobox, ComboboxOption } from 'components/ui/combobox';
import { COLLAB_CLUB_GENRES } from 'constants/collab-club';
import { Artist } from 'types';
import { useTranslation } from 'react-i18next';

interface GenresStepProps {
  profile: Artist;
  value: string[];
  onChange: (value: string[]) => void;
}

export function GenresStep({ profile, value, onChange }: GenresStepProps) {
  const { t } = useTranslation('collab-club');
  const genreOptions: ComboboxOption[] = COLLAB_CLUB_GENRES.map((genre) => ({
    value: genre,
    label: genre.charAt(0).toUpperCase() + genre.slice(1), // Capitalize first letter
  }));

  return (
    <div className="space-y-6">
      <div className="">
        <h3 className="text-lg font-semibold text-gray-900">{t('select_genres')}</h3>
      </div>

      <div>
        <Combobox
          options={genreOptions}
          value={value}
          onValueChange={(v) => onChange(v as string[])}
          placeholder={t('select_placeholder')}
          searchPlaceholder={t('search_placeholder_generic')}
          emptyText={t('nothing_found')}
          multiple={true}
        />
      </div>
    </div>
  );
}
